import { ItemTypeConsts } from 'client/util/Constants';
import { featureFlags } from 'client/store/modules/FeatureFlagsModule';
import { trialPropsData } from 'client/util/Constants/FeatureTrialConstants';
import CloudInsightsConstants from 'client/CloudInsights/constants/CloudInsightsConstants';

const CloudInsightsMainPanel = () => import('client/CloudInsights/CloudInsightsMainPanel.vue');
const ManageAccountsPanel = () => import('client/CloudInsights/ManageAccounts/ManageAccountsPanel.vue');

const {
  routeConsts,
  routeNames,
} = CloudInsightsConstants;
const trialModalProps = {
  feature: ItemTypeConsts.cloudInsights,
  modalProps: trialPropsData.cloudInsights,
};

export default (enabledFlags) => {
  function featureFlagGuard(flag) {
    return (to, from, next) => {
      const showRoute = !!enabledFlags[flag];

      if (showRoute) {
        next();
      } else {
        // If coming from outside JC, route to the home page, else go to previous
        const redirect = from.path === '/' ? { path: '/home' } : from;
        next(redirect);
      }
    };
  }

  return [
    {
      path: '/cloudinsights',
      name: routeNames[routeConsts.cloudInsightsMain],
      meta: {
        title: 'Cloud Insights',
        loadLegacyStyles: false,
        defaultPremiumBadgeVisibility: true,
        ...trialModalProps,
      },
      components: {
        mainPanel: CloudInsightsMainPanel,
      },
      beforeEnter: featureFlagGuard(featureFlags.cloudInsights),
    },
    {
      path: '/cloudinsights/accounts',
      name: routeNames[routeConsts.cloudInsightsAccounts],
      meta: {
        title: 'Cloud Insights',
        returnPath: '/cloudinsights',
        loadLegacyStyles: false,
        ...trialModalProps,
      },
      components: {
        mainPanel: ManageAccountsPanel,
      },
      beforeEnter: featureFlagGuard(featureFlags.cloudInsights),
    },
  ];
};
